export default "__VITE_ASSET__B2U1wPI4__"